import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ApiService } from '@core/api/api.service';
import * as M from '@core/api/models';
import type {
  MediaOwnerAttachmentsReplaceRequest,
  MediaOwnerAttachmentsReplaceResponseDto,
} from '@core/api/contracts';
import {
  MediaAttachmentsApiClient,
  MediaAttachmentsOwnerViewModel,
  MediaRoleCode,
} from '@core/media';

@Injectable({ providedIn: 'root' })
export class DeveloperApiClient {
  private readonly api = inject(ApiService);
  private readonly mediaAttachmentsApi = inject(MediaAttachmentsApiClient);
  private readonly http = inject(HttpClient);
  private readonly apiUrl: string;

  constructor() {
    const baseUrl = environment.apiUrl || 'http://localhost:8080';
    this.apiUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    });
  }

  getDeveloper(): Observable<M.DeveloperDto> {
    return this.http.get<M.DeveloperDto>(`${this.apiUrl}/api/v1/developers`);
  }

  updateDeveloper(data: M.DeveloperUpdateRequest): Observable<M.DeveloperDto> {
    return this.http.put<M.DeveloperDto>(
      `${this.apiUrl}/api/v1/developers`,
      data,
      { headers: this.getHeaders() }
    );
  }

  updateMainCompany(companyId: number): Observable<M.DeveloperDto> {
    return this.http.put<M.DeveloperDto>(
      `${this.apiUrl}/api/v1/developers/main-company/${companyId}`,
      null,
      { headers: this.getHeaders() }
    );
  }

  getDeveloperAttachments(
    developerId: number,
    roles?: MediaRoleCode[]
  ): Observable<MediaAttachmentsOwnerViewModel> {
    return this.mediaAttachmentsApi.getOwnerAttachments('DEVELOPER', developerId, roles);
  }

  replaceDeveloperAttachments(
    request: MediaOwnerAttachmentsReplaceRequest
  ): Observable<MediaOwnerAttachmentsReplaceResponseDto> {
    return this.mediaAttachmentsApi.replaceOwnerAttachments(request);
  }
}
